import cx from "classnames";
import { ReactNode } from "react";

import { usePoolsIsMobilePage } from "pages/Pools/usePoolsIsMobilePage";

import { SyntheticsInfoRow } from "components/Synthetics/SyntheticsInfoRow";
import TooltipWithPortal from "components/Tooltip/TooltipWithPortal";

export function PoolsDetailsMarketAmount({
  value,
  // secondaryValue,
  label,
  tooltipContent,
}: {
  value: ReactNode;
  // Kept in the component contract while the secondary-value UI remains intentionally hidden.
  // eslint-disable-next-line react/no-unused-prop-types
  secondaryValue?: string;
  label?: ReactNode;
  tooltipContent?: ReactNode;
}) {
  const isMobile = usePoolsIsMobilePage();

  const valueContent = (
    <span className={cx("flex items-center", { "gap-8": !isMobile, "gap-4": isMobile })}>
      <span className="leading-none text-[14px] font-medium uppercase text-white">{value}</span>
      {/* {secondaryValue ? (
        <span className={cx("text-gray-lighter", { "text-body-medium": !isMobile, "text-body-small": isMobile })}>
          {`(${secondaryValue})`}
        </span>
      ) : null} */}
    </span>
  );

  const valueContentWithTooltip = tooltipContent ? (
    <TooltipWithPortal handle={valueContent} content={tooltipContent} />
  ) : (
    valueContent
  );

  if (isMobile) {
    return <SyntheticsInfoRow label={label} value={valueContentWithTooltip} />;
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="leading-none text-[13px] font-medium text-gray-lighter">{label}</div>
      {valueContentWithTooltip}
    </div>
  );
}
